<template>
  <div class="chat-left">
    <div class="search">
      <svg
        width="24"
        height="24"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Search">
          <path
            id="Vector"
            d="M12.2029 3.32971C13.7731 3.32965 15.312 3.76844 16.6461 4.59658C17.9801 5.42472 19.0562 6.60923 19.7528 8.01644C20.4494 9.42366 20.7388 10.9976 20.5884 12.5605C20.438 14.1235 19.8537 15.6133 18.9016 16.8619L24.2289 22.1914C24.4303 22.3935 24.5473 22.6648 24.556 22.95C24.5647 23.2352 24.4645 23.5131 24.2758 23.7271C24.087 23.9412 23.8239 24.0753 23.5398 24.1024C23.2557 24.1295 22.972 24.0474 22.7463 23.8728L22.6407 23.7796L17.3111 18.4523C16.2475 19.2634 15.006 19.8095 13.6894 20.0454C12.3727 20.2814 11.0189 20.2004 9.73974 19.8092C8.46062 19.4181 7.29304 18.7279 6.33362 17.7959C5.37419 16.8638 4.65051 15.7167 4.22244 14.4495C3.79438 13.1822 3.67424 11.8313 3.87197 10.5084C4.0697 9.18545 4.57961 7.92865 5.35952 6.84195C6.13942 5.75525 7.1669 4.86989 8.35692 4.25913C9.54694 3.64838 10.8653 3.32978 12.2029 3.32971ZM12.2029 5.57609C10.5645 5.57609 8.99322 6.22693 7.83471 7.38545C6.6762 8.54396 6.02535 10.1152 6.02535 11.7536C6.02535 13.392 6.6762 14.9633 7.83471 16.1218C8.99322 17.2803 10.5645 17.9312 12.2029 17.9312C13.8413 17.9312 15.4126 17.2803 16.5711 16.1218C17.7296 14.9633 18.3804 13.392 18.3804 11.7536C18.3804 10.1152 17.7296 8.54396 16.5711 7.38545C15.4126 6.22693 13.8413 5.57609 12.2029 5.57609Z"
            fill="#707991"
          />
        </g>
      </svg>
      <input
        type="text"
        v-model="search"
        placeholder="Search"
        @input="searchFn"
      />
    </div>

    <div class="chat-list">
      <div
        class="item"
        v-for="(message, index) in sortLastMessages"
        :key="index"
        v-if="!usersAvaliable || (Array.isArray(usersAvaliable) && usersAvaliable.includes(users[message.idUser]))"
        @click="openChatRight(message.idUser, users[message.idUser])"
      >
        <avatar :username="userNameAvatar(users[message.idUser])"></avatar>
        <div class="message">
          <div class="left">
            <div class="name">{{ users[message.idUser] }}</div>
            <div class="img" v-if="checkImg(message.message)">
              <img :src="getImgUrl(message.message)" />
            </div>
            <span v-else>{{ message.message }}</span>
          </div>

          <div>
            <div class="time" v-if="message.time">
              {{ formatTime(message.time) }}
            </div>
            <div class="bagde" v-if="message.messageUnread">
              {{ message.messageUnread }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
import debounce from "lodash.debounce";
import FuzzySearch from "fuzzy-search";

export default {
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
    users: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Avatar,
  },
  data() {
    return {
      search: "",
      usersAvaliable: null,
      renderSortLastMessages: false,
    };
  },
  computed: {
    sortLastMessages() {
      // render again when localStorage change
      if(this.renderSortLastMessages) {}

      let sortMessages = [...this.messages];
      sortMessages.sort((messageA, messageB) => {
        return messageB.time - messageA.time;
      });

      const countMessagesUnread = JSON.parse(localStorage.getItem("countMessagesUnread")) || {};
  
      sortMessages.forEach((message, i) => {
        if (countMessagesUnread[message.idUser]) {
          sortMessages[i].messageUnread = countMessagesUnread[message.idUser];
        } else {
          sortMessages[i].messageUnread = 0;
        }
      });

      return sortMessages;
    },
  },
  methods: {
    formatTime(timestamp) {
      let h = new Date(timestamp).getHours();
      let m = new Date(timestamp).getMinutes();

      h = h < 9 ? "0" + h : h;
      m = m < 9 ? "0" + m : m;

      return h + ":" + m;
    },
    searchFn: debounce(function () {
      this.handleSearch();
    }, 200),

    handleSearch() {
      const self = this;
      const searcher = new FuzzySearch(Object.values(self.users), [], {
        caseSensitive: true,
      });
      const result = searcher.search(self.search);
      self.usersAvaliable = result;
    },

    checkImg(text) {
      if (text.indexOf("/api/util/file") > -1) {
        return true;
      }
      return false;
    },

    getImgUrl(img) {
      return `${process.env.VUE_APP_BASE_URL}${img}`;
    },

    userNameAvatar(userName) {
      if (userName) {
        return userName;
      }
      return "A";
    },

    openChatRight(idUser, userName) {
      this.$emit('sendIdChat', idUser, userName);
      const countMessagesUnread = JSON.parse(localStorage.getItem("countMessagesUnread")) || {};
      if (countMessagesUnread[idUser]) {
        delete countMessagesUnread[idUser];
      }
      localStorage.setItem("countMessagesUnread", JSON.stringify(countMessagesUnread));
      this.renderSortLastMessages = !this.renderSortLastMessages;
    }
  },
};
</script>

<style lang="scss" scoped>
.chat-left {
  .search {
    position: relative;
    svg {
      position: absolute;
      top: 8px;
      left: 18px;
    }
    input {
      width: 100%;
      border-radius: 10px;
      background: #fff;
      border: 0;
      outline: none;
      padding: 9px 18px;
      padding-left: 55px;
      color: #707991;
    }
  }
  .chat-list {
    background-color: #fff;
    border-radius: 10px;
    margin: 20px 0;
    .item {
      padding: 12px 16px;
      display: flex;
      align-items: center;
      cursor: pointer;
      .message {
        display: flex;
        justify-content: space-between;
        margin-left: 16px;
        width: calc(100% - 66px);
        .left {
          .img {
            img {
              height: 30px;
            }
          }
          .name {
            color: #011627;
            font-size: 16px;
            font-weight: 600;
            line-height: 20px;
          }
          span {
            color: #707991;
            font-size: 14px;
            line-height: 18px;
          }
        }
        .time {
          color: #707991;
          font-size: 12px;
        }
      }
    }
  }

  .bagde {
    width: 19px;
    height: 19px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: red;
    border-radius: 100%;
    color: #fff;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
  }
}
</style>
